// extracted by mini-css-extract-plugin
export default {"AccordionHeader":"📚19-10-2zAswq","ContentWrapper":"📚19-10-2pynEn"};